/*eslint-disable no-undef*/
/* global translate */

import { connect } from 'react-redux'
import fetch from 'isomorphic-fetch'

import * as Jsx from './index.jsx'

const RxComponent = global.rootRequire('components/shares/rxComponent').default

const { rxaget, rxChangeSlug, sortArrObj, changeColorSVG } = global.rootRequire('classes/ulti')

const { clickCreateGroupPopup } = global.rootRequire('redux')


const rxio = global.rootRequire('classes/socket').default

class SearchComponent_ extends RxComponent {
  constructor(props, context) {
    super(props, context, Jsx)
    this.state = {
      groupsSearchBoxClickStatus: false,
      groups: [],
      groupsNChatOrigin: [],
      contactInfo: {},
      windowHeight: window.innerHeight - 120,
      flagEdit: true
    }

    this.user = rxaget(this.props, 'netaauth.user', {})
    this.token = rxaget(this.user, 'token', '')
  }

  componentWillUnmount() {
  }

  getSearchBoxvalue(clickStatus, searchValue) {
    this.setState({
      // groupsSearchBoxClickStatus: clickStatus,
      // searchValue: searchValue,
    })
  }

  searchBox_chooseGroup() {

  }

  createNewChatGroup(type_popup) {
    this.setState({ flagShowDropDown: false }, () => {
      const user = rxaget(this.props, 'netaauth.user', {})
      this.props.clickCreateGroupPopup(type_popup, { data: { groups: [], user: user } }, (data) => { })
    })
  }

  chooseContact() {

  }

  onClickAddContact(ele) {
    let info = { Username: ele.phone, Fullname: ele.full_name, Id: ele.Id }
    this.setState({ displayAddContact: true, contactInfo: info })
  }

  onSubmitContact() {
    let addContactValue = this.state.contactInfo || {}
    let address_book_link = global.rxu.config.base_api_neta + '/api/address_book/create'
    let arrContacts = addContactValue
    let params = { "Fullname": arrContacts.Fullname, "Username": arrContacts.Username }

    if (!addContactValue.Username && addContactValue.Id) {
      params = { "Fullname": arrContacts.Fullname, "user_id": arrContacts.Id }
    }

    let headers = { 'Accept': 'application/json', 'Content-Type': 'application/json; charset=utf-8', 'TC-Token': this.token }
    fetch(address_book_link, {
      method: 'POST',
      body: JSON.stringify(params),
      headers: headers
    }).then((res) => { return res.json() })
      .then((json) => {
        try {
          // let that = this
          // fetchContact({ netaContact: rxaget(that.props, 'netaContact.data', {}), token: that.token }, (newContacts) => {
          //   that.props.contactAdd(newContacts)

          //   this.fetchData()
          // })
          this.setState({
            displayAddContact: false,
            flagEdit: false,
            contactInfo: {}
          })
        } catch (error) { console.log(error) }

      }).catch(er => console.log(er))
  }

  groupsSearchBoxClick() {
    let groupsSearchBoxClickStatus = this.state.groupsSearchBoxClickStatus
    this.setState({
      groupsSearchBoxClickStatus: !groupsSearchBoxClickStatus,
      windowHeight: (window && window.innerHeight) ? window.innerHeight - 60 : 1000
    })
  }


  render() {
    return this.renderComponent()
  }
}

const mapStateToProps = (state, ownProps) => ({
  themeValue: state.themeValue,
  themeBackgroudValue: state.themeBackgroudValue,
  langValue: state.langValue,
  user: state.user,
  netaauth: state.netaauth,
  rxgroup: state.rxgroup
})

const mapDispatchToProps = {
  clickCreateGroupPopup
  // userAdd,
  // userAddArr,
  // contactAdd,
  // netaGroupsUpdate,
  // netaGroupsUpdateArr,
  // netaBlobsUpdate,
  // chooseGroupAction,
  // changeStatusTabmore,
  // changeStatusLoadMess,
  // netaAuthSettingUpdate,
  // netaGroupsPinUpdate,
  // netaGroupsRemove,
  // netaGroupsUpdateUnpin,
  // clearRxContact,
  // clickPopup,
  // clickCreateGroupPopup,
  // netaMessGet,
  // netaMessAdd,
  // netaUserSetGroupid,
  // netaMessRemove,
  // updateUserStatus,
  // removeGroupsDraft,
  // netalogoutAction,
  // setComp
}

const SearchWrapped = connect(
  mapStateToProps,
  mapDispatchToProps
)(SearchComponent_)

export default SearchWrapped